import _ from 'underscore';
import React from 'react';
import { layoutConfigs } from './layout-configs';

export const LayoutContext = React.createContext({
  config: layoutConfigs.default,
  change: _.noop,
});
